import { render } from "./FormTrainingTestTable.vue?vue&type=template&id=0d461d62&scoped=true&ts=true"
import script from "./FormTrainingTestTable.vue?vue&type=script&lang=ts"
export * from "./FormTrainingTestTable.vue?vue&type=script&lang=ts"

import "./FormTrainingTestTable.vue?vue&type=style&index=0&id=0d461d62&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d461d62"]])

export default __exports__